import { formatElement, formatString } from "./format.js";
import { loadTranslations } from "./api.js";
function createTranslateFunction(translations, showError) {
  if (!translations)
    throw new Error('"translations" is invalid');
  const shownErrorsMap = {};
  function lookup(key) {
    if (key in translations) {
      return translations[key];
    }
    if (showError) {
      !shownErrorsMap[key] && console.log(`Unknown translation "${key}"`);
      shownErrorsMap[key] = true;
    }
    return key.toUpperCase();
  }
  function t(key, ...args) {
    return formatString(lookup(key), args);
  }
  t.element = function(key, ...args) {
    return formatElement(lookup(key), args);
  };
  return t;
}
export {
  createTranslateFunction,
  loadTranslations
};
//# sourceMappingURL=index.js.map
